import { countries } from "../../shared/assets/countries";
import { isDefined } from "../../shared/utils/assert";

/**
 * The shared country list declares its flags with `require`, which the phone hands straight to an
 * Image. The web bundler answers with an empty module, so an <img> given it rendered nothing and
 * its src read "[object Object]". The flags are served from /static instead, as the rest of the
 * artwork is, and the entry's own `flag` still says whether the country has one.
 */
export function flagUrl(countryCode?: string): string | undefined {
  if (!countryCode || !isDefined(countries[countryCode]?.flag)) {
    return undefined;
  }
  return `/static/flags/${countryCode}.png`;
}
